import styled from 'styled-components';

const NotesContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 20px;

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    max-width: 100%;
    padding: 16px;
  }

  .headerContainer {
    margin-top: 22px;
    display: flex;
    flex-direction: row;
    align-items: center;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '1200px'}) {
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
    }
  }

  .addNote {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 14px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 0.79;
    letter-spacing: normal;
    text-align: center;
    color: ${(props) => props.theme.colors['white']};
    flex-direction: row-reverse;
    min-width: 210px;
    text-transform: none;
    span {
      margin-left: 10px;
    }
  }

  .kpiValueText {
    text-transform: none;
    font-size: 10px;
    margin-top: 1px;
  }

  .kpi {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 14px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.71;
    letter-spacing: normal;
  }

  .filters,
  .navigation {
    margin-top: 20px;
  }

  .navigation {
    margin-bottom: 20px;
  }

  .surveyContent {
    @media (min-width: 845px) {
      line-height: 20px;
    }
  }

  .pagination {
    @media (max-width: 1200px) {
      margin-left: auto;
      margin-right: auto;
    }
  }
`;

export default NotesContainer;
